export type ProfileMenuItem = 'Icon' | 'Profile' | 'Language' | 'Logout';

export const ProfileMenuItem = {
  Icon: 'Icon' as ProfileMenuItem,
  Profile: 'Profile' as ProfileMenuItem,
  ChangePassword: 'Change Password' as ProfileMenuItem,
  Language: 'Language' as ProfileMenuItem,
  Legal: 'Legal' as ProfileMenuItem,
  TermsAndConditions: 'Terms and Conditions' as ProfileMenuItem,
  PrivacyPolicy: 'Privacy Policy' as ProfileMenuItem,
  Logout: 'Logout' as ProfileMenuItem,
};
